/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Enable_Disable_TitleInputs */



/**
* | output |
* | --- |
* | "Enable/Disable" |
*
* @param {Tags_Manager_Enable_Disable_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_enable_disable_title = /** @type {((inputs?: Tags_Manager_Enable_Disable_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Enable_Disable_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer/Desactiver")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivieren/Deaktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita/Disabilita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить/Выключить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar/Deshabilitar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用/禁用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("有効化/無効化")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अक्षम सक्षम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar/Desativar")
	return /** @type {LocalizedString} */ ("Enable/Disable")
});